import {
  USERS_ACCESS_ROLE_LABEL_KEYS,
  USERS_ACCESS_STATE_LABEL_KEYS,
  USERS_ACCESS_TYPE_LABEL_KEYS,
} from '../../constants/usersAccess'
import {
  USERS_ACCESS_ACCOUNT_STATES,
  USERS_ACCESS_ACCOUNT_TYPES,
  USERS_ACCESS_ROLES,
  type UsersAccessFilterCountsI,
} from '../../types/usersAccess'
import type { UsersAccessFilterFormInputsI } from '../../types/usersAccessFilters'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import type { ColorScheme } from '@hivewatch/dark'
import { Flex } from '@hivewatch/dark'

import { MultiSelectFilterField } from '@/components/filter-drawer'
import { tVar } from '@/utils/i18n'

interface UsersAccessFilterFormIProps {
  colorScheme: ColorScheme
  control: Control<UsersAccessFilterFormInputsI>
  counts: UsersAccessFilterCountsI
}

export const UsersAccessFilterForm = ({
  colorScheme,
  control,
  counts,
}: UsersAccessFilterFormIProps) => {
  const { t } = useTranslation()
  const optionLabel = (label: string, count: number) =>
    tVar(t, 'settings:rebrand_users_filter_option_count', { label, count })

  const roleOptions = USERS_ACCESS_ROLES.map((role) => ({
    value: role,
    label: optionLabel(
      t(USERS_ACCESS_ROLE_LABEL_KEYS[role]),
      counts.roles[role]
    ),
  }))
  const stateOptions = USERS_ACCESS_ACCOUNT_STATES.map((state) => ({
    value: state,
    label: optionLabel(
      t(USERS_ACCESS_STATE_LABEL_KEYS[state]),
      counts.accountStates[state]
    ),
  }))
  const typeOptions = USERS_ACCESS_ACCOUNT_TYPES.map((type) => ({
    value: type,
    label: optionLabel(
      t(USERS_ACCESS_TYPE_LABEL_KEYS[type]),
      counts.accountTypes[type]
    ),
  }))

  return (
    <Flex direction='column' gap='16px'>
      <MultiSelectFilterField
        colorScheme={colorScheme}
        control={control}
        data-testid='usersAccess_filterDrawer_roles'
        label={t('settings:rebrand_users_filter_roles_label')}
        name='roles'
        options={roleOptions}
        placeholder={t('settings:rebrand_users_filter_roles_placeholder')}
      />
      <MultiSelectFilterField
        colorScheme={colorScheme}
        control={control}
        data-testid='usersAccess_filterDrawer_accountState'
        label={t('settings:rebrand_users_filter_account_state_label')}
        name='accountStates'
        options={stateOptions}
        placeholder={t(
          'settings:rebrand_users_filter_account_state_placeholder'
        )}
      />
      <MultiSelectFilterField
        colorScheme={colorScheme}
        control={control}
        data-testid='usersAccess_filterDrawer_accountType'
        label={t('settings:rebrand_users_filter_account_type_label')}
        name='accountTypes'
        options={typeOptions}
        placeholder={t(
          'settings:rebrand_users_filter_account_type_placeholder'
        )}
      />
    </Flex>
  )
}
